'use client'
import { ComponentProps, useEffect, useState } from "react"

function cleanDocument(value: string): string {
  // Por enquanto, mantém apenas números
  return value.replace(/\D/g, '')
  // Futuro (julho/2026 em diante): mantém letras e números
  // return value.replace(/[^a-zA-Z0-9]/g, '')
}

export function CpfMask(value: string): string {
  return value
    // CPF
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    .slice(0, 14)
}

export function CnpjMask(value: string): string {
  if (/^\d+$/.test(value)) {
    return value
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .slice(0, 18)
  }
  return value.slice(0, 20)
}

function getMaskedValue(cleanValue: string): string {
  // Se tem até 11 dígitos → formata como CPF (permite digitação parcial)
  if (cleanValue.length <= 11) {
    return CpfMask(cleanValue)
  }
  // Se tem mais de 11 dígitos → formata como CNPJ
  return CnpjMask(cleanValue)
}

interface TextInputMaskProps extends Omit<ComponentProps<'input'>, 'onChange'> {
  onChange?: (value: string) => void
  value?: string
}

export function TextInputMask({ value = '', onChange, ...props }: TextInputMaskProps) {
  const [formattedValue, setFormattedValue] = useState('')

  useEffect(() => {
    // const clean = cleanAlphanumeric(value)
    // const formatted = clean.length <= 11 ? CpfMask(value) : CnpjMask(value)

    const clean = cleanDocument(value)
    const formatted = getMaskedValue(clean)
    setFormattedValue(formatted)
  }, [value])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value
    // const clean = cleanAlphanumeric(inputValue)
    // const formatted = clean.length <= 11 ? CpfMask(inputValue) : CnpjMask(inputValue)
    const clean = cleanDocument(inputValue)
    const formatted = getMaskedValue(clean)
    setFormattedValue(formatted)
    if (onChange) {
      onChange(clean)
    }
  }

  return (
    <input
      type="text"
      value={formattedValue}
      onChange={handleInputChange}
      className={`py-2 px-3 
        outline-hidden appearance-none 
        rounded-sm shadow 
        border border-dark_secondary dark:border-light_secondary 
        dark:bg-silver-500 
        focus:ring-ochre_accent focus:border-ochre_accent`}
      {...props}
    />
  )
}

